const roundNumber = (num: number, decimalPlaces: number = 0): number => {
  const factor = Math.pow(10, decimalPlaces);
  return Math.round(num * factor) / factor;
};

export default roundNumber;
